// 20.2.2.28 Math.sign(x)
var $export = require(32);

$export($export.S, 'Math', {sign: require(61)});